import React from 'react';
import PropTypes from 'prop-types';
import { HeadingWrapper } from './PageHeading.css';

const PageHeading = ({ text, isDesktop }) => (
  <HeadingWrapper data-cy="page-title" isDesktop={isDesktop}>
    {text}
  </HeadingWrapper>
);

PageHeading.propTypes = {
  isDesktop: PropTypes.bool,
  text: PropTypes.string.isRequired
};

export default PageHeading;
